// angular
import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'pwj-panel-comment-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderModule, NgClass],
  templateUrl: './panel-comment-skeleton.component.html',
  styleUrl: './panel-comment-skeleton.component.scss',
})
export class PanelCommentSkeletonComponent {
  // inputs
  count = input<number>(1);
  containerClasses = input<string>();

  public counter(i: number) {
    return new Array(i);
  }
}
